
import React, { useEffect, useState } from "react";
import { useSidebar } from "./SidebarContext";
import { useInstitute } from "./commonComponents/InstituteContext";
import ProfileDropdown from "./commonComponents/ProfileDropdown";
import { useAuth } from "./AuthContext";
import { LuGraduationCap } from "react-icons/lu";
import { useParams } from "react-router-dom";
import { Dropdown, Modal, Button } from "react-bootstrap";
import { BsThreeDotsVertical, BsEyeFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

function ViewExam() {
  const { studentId } = useParams();
  const { logout } = useAuth();
  const { isCollapsed } = useSidebar();
  const { logo, name: instituteName } = useInstitute();
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedExam, setSelectedExam] = useState(null);
  const [logoError, setLogoError] = useState(false);
  const [marginLeft, setMarginLeft] = useState("0px");
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245;
        const collapsedWidth = 85;
        const gap = 1;
        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`
        );
      } else {
        setMarginLeft("0px");
      }
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isCollapsed]);

  const handleViewDetails = (item) => {
    setSelectedExam(item);
    setShowViewModal(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://schoolapi.virtualprachar.com/api/exam/student-schedules?student_id=${studentId}`,
          {
            method: "GET",
            headers: {
              Authorization:
                "Bearer 5579|dWIH5hv1jyTTluz1Pr7iDFbKaaOKJd32Zth7pM1s08f33a46",
              "Institute-Id": "7",
              Accept: "application/json",
            },
          }
        );
        const result = await response.json();
        setData(result);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  /* ── Mobile card for one exam row ── */
  const ExamMobileCard = ({ item, index }) => (
    <div
      style={{
        border: "1px solid #D1D3D4",
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        marginBottom: "12px",
        overflow: "hidden",
      }}
    >
      {/* Card rows */}
      {[
        { label: "S/No", value: index + 1 },
        { label: "Course Name", value: item.course?.name || "-" },
        { label: "Exam Name", value: item.exam_name || "-" },
      ].map(({ label, value }) => (
        <div
          key={label}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
            borderBottom: "1px solid #F3F4F6",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontWeight: "600",
              color: "#6b7280",
              fontFamily: "Inter, system-ui, sans-serif",
              // minWidth: "120px",
            }}
          >
            {label}
          </span>
          <span
            style={{
              fontSize: "14px",
              color: "#111827",
              fontFamily: "Inter, system-ui, sans-serif",
              textAlign: "right",
            }}
          >
            {value}
          </span>
        </div>
      ))}

      {/* Status row */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 16px",
          borderBottom: "1px solid #F3F4F6",
        }}
      >
        <span
          style={{
            fontSize: "13px",
            fontWeight: "600",
            color: "#6b7280",
            fontFamily: "Inter, system-ui, sans-serif",
          }}
        >
          Status
        </span>
        <span
          style={{
            background: item.status === "upcoming" ? "#FEF3C7" : "#DCFCE7",
            color: item.status === "upcoming" ? "#92400E" : "#166534",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: "600",
            textTransform: "capitalize",
            fontFamily: "Inter, system-ui, sans-serif",
          }}
        >
          {item.status}
        </span>
      </div>

      {/* Action row */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 16px",
        }}
      >
        <span
          style={{
            fontSize: "13px",
            fontWeight: "600",
            color: "#6b7280",
            fontFamily: "Inter, system-ui, sans-serif",
          }}
        >
          Action
        </span>
        <div style={{ display: "flex", gap: "8px" }}>
          <button
            onClick={() =>
              navigate(`/ExamSheet/Admitcard/${studentId}/${item.id}`)
            }
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              backgroundColor: "#223843",
              border: "none",
              color: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#1f323a";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#223843";
              e.currentTarget.style.transform = "scale(1)";
            }}
            title="Admit Card"
          >
            <BsEyeFill size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <style>
        {`
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }
          .dropdown-menu {
            z-index: 9999 !important;
            position: absolute !important;
          }
        `}
      </style>

      <div
        style={{
          marginLeft,
          transition: "margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
          position: "relative",
          zIndex: 1,
          paddingLeft: "12px",
          paddingRight: "12px",
        }}
      >
        {/* ── HEADER ── */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? "55px" : "-12px",
            paddingLeft: "0px",
            paddingRight: "0px",
          }}
        >
          <div style={{ marginLeft: isMobile ? "-13px" : "-40px" }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                background: "#F3F4F6",
                paddingLeft: "28px",
                paddingRight: "28px",
                paddingTop: "12px",
                paddingBottom: "12px",
                borderBottom: "1px solid #D1D3D4",
                width: "100%",
              }}
            >
              {/* Left */}
              <div className="d-flex align-items-center gap-3">
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    background: "#223843",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {!logoError ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: "#fff" }} />
                  )}
                </div>

                <div>
                  <h3
                    className="m-0 fw-bold"
                    style={{
                      fontSize: "clamp(18px, 2.5vw, 22px)",
                      color: "#223843",
                      fontFamily: "Inter, system-ui, sans-serif",
                      textAlign: "left",
                    }}
                  >
                    Student Eligible Exams
                  </h3>
                  <p
                    className="m-0 mt-1"
                    style={{
                      fontSize: "13px",
                      color: "#6b7280",
                      fontFamily: "Inter, system-ui, sans-serif",
                    }}
                  >
                    {instituteName ? `${instituteName} · ` : ""}
                    Manage student admit cards
                  </p>
                </div>
              </div>

              {/* Right */}
              {!isMobile && <ProfileDropdown logout={logout} />}
            </div>
          </div>
        </div>

        {/* ── Content Area ── */}
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: "100vh",
            paddingLeft: isMobile ? "0px" : "40px",
            paddingRight: isMobile ? "0px" : "32px",
            paddingTop: "0px",
            paddingBottom: "32px",
          }}
        >
          {loading && (
            <h4 style={{ fontFamily: "Inter, system-ui, sans-serif", color: "#6b7280" }}>
              Loading...
            </h4>
          )}
          {error && (
            <h4 style={{ color: "red", fontFamily: "Inter, system-ui, sans-serif" }}>
              {error}
            </h4>
          )}

          {data?.data?.length > 0 && (
            <>
              {/* ── MOBILE: card layout ── */}
              {isMobile ? (
                <div style={{ padding: "0 4px" }}>
                  <div
                    style={{
                      padding: "14px 16px",
                      marginBottom: "12px",
                    }}
                  >
                    <h4
                      style={{
                        margin: 0,
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#111827",
                        fontFamily: "Inter, system-ui, sans-serif",
                      }}
                    >
                      Eligible Exams List
                    </h4>
                  </div>

                  {data.data.map((item, index) => (
                    <ExamMobileCard key={item.id} item={item} index={index} />
                  ))}
                </div>
              ) : (
                /* ── DESKTOP: table layout (unchanged) ── */
                <div
                  style={{
                    border: "1px solid #D1D3D4",
                    borderRadius: "12px",
                    overflow: "visible",
                    backgroundColor: "#ffffff",
                    position: "relative",
                  }}
                >
                  {/* Card header */}
                  <div
                    style={{
                      padding: "18px 24px",
                      borderBottom: "1px solid #E5E7EB",
                      background: "#F9FAFB",
                      borderRadius: "12px 12px 0 0",
                    }}
                  >
                    <h4
                      style={{
                        margin: 0,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "#111827",
                        fontFamily: "Inter, system-ui, sans-serif",
                      }}
                    >
                      Eligible Exams List
                    </h4>
                  </div>

                  {/* Table */}
                  <div
                    style={{
                      overflowX: "auto",
                      overflowY: "visible",
                      position: "relative",
                      borderRadius: "0 0 12px 12px",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginBottom: 0,
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: "#F3F4F6" }}>
                          {["S/No", "Course Name", "Exam Name", "Status", "Actions"].map(
                            (col) => (
                              <th
                                key={col}
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "600",
                                  padding: "16px",
                                  borderBottom: "1px solid #D1D3D4",
                                  textAlign:
                                    col === "Actions" || col === "Status"
                                      ? "center"
                                      : "left",
                                  color: "#111827",
                                  fontFamily: "Inter, system-ui, sans-serif",
                                }}
                              >
                                {col}
                              </th>
                            )
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {data.data.map((item, index) => (
                          <tr
                            key={item.id}
                            style={{
                              backgroundColor:
                                index % 2 === 0
                                  ? "#ffffff"
                                  : "rgba(243,244,246,0.4)",
                              borderBottom: "1px solid #E5E7EB",
                              transition: "background-color 0.2s ease",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "rgba(37,99,235,0.06)")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                index % 2 === 0
                                  ? "#ffffff"
                                  : "rgba(243,244,246,0.4)")
                            }
                          >
                            <td
                              style={{
                                fontSize: "14px",
                                padding: "16px",
                                color: "#111827",
                                fontFamily: "Inter, system-ui, sans-serif",
                                textAlign: "left",
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                padding: "16px",
                                color: "#111827",
                                fontFamily: "Inter, system-ui, sans-serif",
                                textAlign: "left",
                              }}
                            >
                              {item.course?.name || "-"}
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                padding: "16px",
                                color: "#111827",
                                fontFamily: "Inter, system-ui, sans-serif",
                                textAlign: "left",
                              }}
                            >
                              {item.exam_name || "-"}
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                padding: "16px",
                                textAlign: "center",
                              }}
                            >
                              <span
                                style={{
                                  background:
                                    item.status === "upcoming"
                                      ? "#FEF3C7"
                                      : "#DCFCE7",
                                  color:
                                    item.status === "upcoming"
                                      ? "#92400E"
                                      : "#166534",
                                  padding: "5px 12px",
                                  borderRadius: "20px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  textTransform: "capitalize",
                                  fontFamily: "Inter, system-ui, sans-serif",
                                }}
                              >
                                {item.status}
                              </span>
                            </td>
                            <td style={{ padding: "16px", textAlign: "center" }}>
                              <Dropdown align="end">
                                <Dropdown.Toggle
                                  variant="light"
                                  className="dropdown-toggle-no-caret"
                                  style={{
                                    width: "36px",
                                    height: "36px",
                                    borderRadius: "50%",
                                    backgroundColor: "transparent",
                                    border: "1px solid #D1D3D4",
                                    padding: "0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto",
                                    transition: "all 0.2s ease",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      "#223843";
                                    e.currentTarget.style.borderColor =
                                      "#223843";
                                    e.currentTarget.style.color = "#ffffff";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      "transparent";
                                    e.currentTarget.style.borderColor =
                                      "#D1D3D4";
                                    e.currentTarget.style.color = "#111827";
                                  }}
                                >
                                  <BsThreeDotsVertical
                                    style={{ color: "inherit" }}
                                  />
                                </Dropdown.Toggle>

                                <Dropdown.Menu
                                  style={{
                                    borderRadius: "8px",
                                    border: "1px solid #E5E7EB",
                                    padding: "8px",
                                    minWidth: "180px",
                                    zIndex: 9999,
                                  }}
                                >
                                  <Dropdown.Item
                                    onClick={() =>
                                      navigate(
                                        `/ExamSheet/Admitcard/${studentId}/${item.id}`
                                      )
                                    }
                                    style={{
                                      fontSize: "13px",
                                      padding: "10px 12px",
                                      color: "#111827",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                      borderRadius: "6px",
                                      transition: "all 0.2s ease",
                                      fontFamily: "Inter, system-ui, sans-serif",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "#223843";
                                      e.currentTarget.style.color = "#ffffff";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.backgroundColor =
                                        "transparent";
                                      e.currentTarget.style.color = "#111827";
                                    }}
                                  >
                                    <BsEyeFill size={16} /> Admit Card
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </>
          )}

          {/* Empty state */}
          {!loading && !error && data?.data?.length === 0 && (
            <div
              style={{
                textAlign: "center",
                padding: "60px 0",
                color: "#6b7280",
                fontFamily: "Inter, system-ui, sans-serif",
              }}
            >
              No exams found for this student.
            </div>
          )}
        </div>
      </div>

      {/* View Modal */}
      <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Admit Card Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedExam && (
            <div className="d-flex flex-column gap-3">
              <div>
                <strong>Course:</strong> {selectedExam.course?.name || "-"}
              </div>
              <div>
                <strong>Exam Name:</strong> {selectedExam.exam_name || "-"}
              </div>
              <div>
                <strong>Session:</strong> {selectedExam.session || "-"}
              </div>
              <div>
                <strong>Status:</strong> {selectedExam.status || "-"}
              </div>
              <div>
                <strong>Passing Marks:</strong>{" "}
                {selectedExam.passing_marks || "-"}
              </div>
              <div>
                <strong>Start Date:</strong>{" "}
                {new Date(selectedExam.start_date).toLocaleDateString()}
              </div>
              <div>
                <strong>End Date:</strong>{" "}
                {new Date(selectedExam.end_date).toLocaleDateString()}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowViewModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ViewExam;

